import md5 from 'md5';
import PropTypes from 'prop-types';
import React from 'react';

class Gravatar extends React.Component {
  static propTypes = {
    user: PropTypes.object,
  };

  render() {
    const { user } = this.props;

    if (!user.email) {
      return (
        <img
          src={
            'https://ui-avatars.com/api/' +
            (user.firstName + ' ' + user.lastName).replace(/ /g, '+') +
            '/128/34bfa3/FFFFFF/2/0.33'
          }
          className="m--img-rounded m--marginless"
          alt=""
        />
      );
    }

    return (
      <img
        src={
          'https://www.gravatar.com/avatar/' +
          md5(user.email) +
          '?s=200&d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/' +
          (user.firstName + ' ' + user.lastName).replace(/ /g, '+') +
          '/128/34bfa3/FFFFFF/2/0.33'
        }
        className="m--img-rounded m--marginless"
        alt=""
      />
    );
  }
}

export default Gravatar;
